import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
import { addAuthRefreshInterceptor } from './tokenLocalStorage';

export class AxiosWrapper<T extends AxiosInstance> {
  client: T;

  constructor(client: T) {
    this.client = client;
    addAuthRefreshInterceptor(this.client);
  }

  get<T = any>(url: string, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.client.get(url, config);
  }

  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.client.post(url, data, config);
  }

  request<T = any>(config: AxiosRequestConfig): AxiosPromise<T> {
    return this.client.request(config);
  }

  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.client.put(url, data, config);
  }

  patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.client.patch(url, data, config);
  }

  head<T = any>(url: string, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.client.get(url, config);
  }

  delete<T = any>(url: string, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.client.delete(url, config);
  }
}